export enum InputfieldValidatorEnum {
    EMAIL = 'email',
    PASSWORD = 'password',
    PHONENUMBER = 'phoneNumber',
    CUSTOM = 'custom',
    NOVALIDATION = 'noValidation'
}